/**
 * Minimal user-agent helpers replacing the `bowser` (v1) dependency. Each check
 * mirrors the semantics of the old bowser flag it replaces:
 *
 * - `isMobile` ⇔ `bowser.mobile` — phones only. Tablets were `bowser.tablet`,
 *   not `mobile`, hence the iPad exclusion (legacy iPad UAs contain "Mobile").
 *   Modern iPadOS requests desktop sites, so it never matched either way.
 * - `isSafari` ⇔ `bowser.safari` — real Safari; Chrome/Firefox/Edge/Opera UAs
 *   (incl. iOS CriOS/FxiOS) also contain "Safari" and must be excluded.
 * - `isWindows` ⇔ `bowser.windows`.
 * - `isSupportedBrowser` ⇔ `chrome || chromium || firefox || safari || blink` —
 *   any Blink/WebKit/Gecko browser; all of them carry at least one of these
 *   tokens.
 */

const ua = () => navigator.userAgent

const isMobile = () => /Mobi/i.test(ua()) && !/iPad/i.test(ua())

const isSafari = () =>
  /Safari/i.test(ua()) &&
  !/Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android/i.test(ua())

const isWindows = () => /Windows/i.test(ua())

const isSupportedBrowser = () =>
  /Chrome|Chromium|CriOS|Firefox|FxiOS|Safari/i.test(ua())

export { isMobile, isSafari, isWindows, isSupportedBrowser }
